module.exports = __webpack_public_path__ + "img/messagesent.0d2f9c69.svg";